module.exports = __webpack_public_path__ + "img/wave_dark.2d4ce57b.gif";